import './SignUp.scss';

import React, { useState, useEffect } from 'react';
import Modal from '../../features/keywords/react/Modal/Modal';
import UpsellSubscription from './UpsellSubscription';
import UpsellContactSupport from './UpsellContactSupport';
import CreateUserAndSubscribe from './CreateUserAndSubscribe';
import RedeemCoupon from './RedeemCoupon';
import ContinueAccessMenu from './ContinueAccessMenu';
import useUpsellEvents from './useUpsellEvents';
import usePosthog from './usePosthog';
import DebugFunnels from './DebugFunnels';
import posthogClient from '../../shared/posthogClient';

const SUBSCRIBE_FUNNELS = ['subscribe', 'paywall_reached'];
const VARIANT_OVERRIDE_KEY = 'signupModalVariantOverride';
const VARIANT_FLAG_KEY = 'signup_modal_variant';

function readVariantOverride() {
  if (typeof localStorage === 'undefined') return null;
  const value = localStorage.getItem(VARIANT_OVERRIDE_KEY);
  return value === 'current' ? value : null;
}

function resolveFlagVariant() {
  return 'current';
  // Re-enable when running a variant test:
  const flag = posthogClient.getFeatureFlag(VARIANT_FLAG_KEY);
  return flag === 'legacy' ? 'legacy' : 'redesigned';
}

export default function SignUp({user}) {

  const { Funnel, PriceId, LastUserAction, reset } = useUpsellEvents(user);
  const [Show, SetShow] = useState(false);
  const [Variant, SetVariant] = useState(readVariantOverride() || resolveFlagVariant());

  useEffect(() => { SetShow(Funnel !== null); }, [Funnel]);

  useEffect(() => {
    const sync = () => {
      const override = readVariantOverride();
      SetVariant(override || resolveFlagVariant());
    };
    sync();
    const unsubscribe = posthogClient.onFeatureFlags(sync);
    const onStorage = e => { if (e.key === VARIANT_OVERRIDE_KEY) sync(); };
    window.addEventListener('storage', onStorage);
    window.addEventListener('signupModalVariantOverrideChanged', sync);
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('signupModalVariantOverrideChanged', sync);
    };
  }, []);

  const handleClose = () => {
    SetShow(false);
    setTimeout(reset, 150);
  };

  const variantMeta = SUBSCRIBE_FUNNELS.includes(Funnel) ? { modal_variant: Variant } : {};
  usePosthog(Funnel, { ...(Funnel === 'coupon' ? { coupon: user.coupon } : {}), ...variantMeta });

  return (

    <>
    {(typeof __IS_PRODUCTION === 'undefined' || !__IS_PRODUCTION) && <DebugFunnels user={user} />}
    <Modal show={Show} dismissable={false} onClose={handleClose}>

      { Funnel === 'coupon' && <RedeemCoupon user={user} priceId={PriceId} /> }

      { Funnel === 'curious_about_even_more_ranking_lists' && <UpsellContactSupport /> }

      { Funnel === 'continue_access' && (
        <ContinueAccessMenu
          user={user}
          onClose={handleClose}
        />
      ) }

      { SUBSCRIBE_FUNNELS.includes(Funnel) && PriceId && (
        <CreateUserAndSubscribe
          priceId={PriceId}
          funnel={Funnel}
          user={user}
          onClose={handleClose}
        />
      ) }

      { ['curious_about_ranking_lists', 'out_of_ranking_lists', 'out_of_daily_searches', 'expired_with_valid_card', 'expired_with_invalid_card'].includes(Funnel) && (
        <UpsellSubscription
          priceId={PriceId}
          funnel={Funnel}
          user={user}
        />
      ) }

    </Modal>
    </>
  )

}
